import { FC } from 'react';
import { Card } from "@/components/ui/card";
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { StudentProgress } from './types';

interface ActivityTabProps {
  studentProgress: StudentProgress | undefined;
}

export const ActivityTab: FC<ActivityTabProps> = ({ studentProgress }) => {
  return (
    <Card className="p-3 md:p-6 bg-white shadow-sm border-[#E6EDF9]">
      <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-[#2B3674]">Resumen de Actividad</h3>
      {studentProgress?.last_activities.length === 0 ? (
        <p className="text-[#707EAE] text-sm md:text-base text-center py-3 md:py-4">
          Aún no hay actividades registradas. ¡Anima a tu estudiante a comenzar su viaje financiero!
        </p>
      ) : (
        <div className="space-y-3 md:space-y-4">
          {studentProgress?.last_activities.map((activity, index) => (
            <div key={index} className="flex items-center justify-between p-2 md:p-3 rounded-lg hover:bg-[#F4F7FE] transition-colors">
              <div>
                <div className="font-medium text-sm md:text-base text-[#2B3674]">{activity.name}</div>
                <div className="text-xs md:text-sm text-[#707EAE]">
                  {activity.type === 'lesson' ? 'Lección completada' : 'Juego explorado'}
                </div>
              </div>
              <div className="text-xs md:text-sm text-[#707EAE]">
                {format(new Date(activity.date), 'PPP', { locale: es })}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
